import React from 'react';
import { Navigate } from 'react-router-dom';
import { Result, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import roleService from '../../service/RoleService';

/**
 * Protected Route Component
 * @param {Object} props
 * @param {React.Component} props.children - The component to render if authorized
 * @param {string|Array} props.roles - Required role(s) to access this route
 * @param {boolean} props.requireAll - If true, user must have ALL roles (default: false)
 * @param {string} props.redirectTo - Path to redirect if not authorized (default: '/')
 * @param {React.Component} props.fallback - Custom fallback component
 */
const ProtectedRoute = ({ 
    children, 
    roles, 
    requireAll = false, 
    redirectTo = '/',
    fallback = null,
    allowManager = false
}) => {
    // Check if user is authenticated
    if (!roleService.isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }

    // If no roles specified, just check authentication
    if (!roles) {
        return children;
    }

    // Convert single role to array
    const requiredRoles = Array.isArray(roles) ? roles : [roles];

    // Check role authorization
    const hasAccess = requireAll
        ? roleService.hasAllRoles(requiredRoles)
        : roleService.hasAnyRole(requiredRoles);

    if (hasAccess || (allowManager && roleService.isManager())) {
        return children;
    }

    // Return fallback component if provided
    if (fallback) {
        return fallback;
    }

    // Default unauthorized component
    return (
        <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
            icon={<LockOutlined style={{ color: '#ff4d4f' }} />}
            extra={
                <Button 
                    type="primary" 
                    onClick={() => window.history.back()}
                    className="btn-recruit btn-primary"
                >
                    Go Back
                </Button>
            }
        />
    );
};

export default ProtectedRoute;
